import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  location: string;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  location,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-orange-100 hover:shadow-md transition-shadow duration-300" data-id="element-14">
      <div className="flex gap-1 mb-4" data-id="element-15">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-orange-400 text-orange-400" data-id="element-16" />)}
      </div>
      <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-17">"{quote}"</p>
      <div className="flex items-center gap-3" data-id="element-18">
        <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-bold text-sm" data-id="element-19">
          {name.charAt(0)}
        </div>
        <div data-id="element-20">
          <p className="font-semibold text-gray-900" data-id="element-21">
            {name}, {age}
          </p>
          <p className="text-xs text-gray-500" data-id="element-22">{location}</p>
        </div>
      </div>
    </div>;
}